import { call, put } from 'redux-saga/effects';

import { ISubscriptionActionResponse } from 'api/types/response';
import api from 'api';

import { openModal } from 'store/modals/actions';
import { fetchDiscountSubscriptionSuccess, updateSubscription } from 'store/subscriptions/actions';
import { checkAllSubscriptionsWithDiscount } from 'store/subscriptions/helpers';

import { CANCEL_OFFER_SUCCESS_SCREEN_ID, DISCOUNT_APPLIED_ERROR, DISCOUNT_APPLIED_SUCCESS } from 'constants/analytics';

import { sendAnalyticDiscountAppliedResult, trackScreenLoadCancelOffer } from 'services/Analytics';

import { ModalName } from 'modals/types';

import { changeSubscriptionErrorModalData, getChangeSubscriptionSuccessModalData } from 'helpers/subscriptions';

import { CancelFlowOffers } from 'types/subscription';

import { pollGetSubscriptions } from './pollGetSubscriptions';
import { handleAuthError } from './utils';

/**
 *
 * Can be applied only to active subscriptions. Calls the switch endpoint,
 * which changes the current subscription to a discounted one.
 */

export function* changeCurrentSubscription({ payload }: ReturnType<typeof updateSubscription>) {
    try {
        yield put(openModal(ModalName.WithLoaderModal, { title: 'subscription.waitingModal.updatingPlan.title' }));

        const result: ISubscriptionActionResponse = yield call(api.subscriptions.updateSubscription, payload);

        if (result.error) {
            throw Error(result.error);
        }

        yield call(pollGetSubscriptions, checkAllSubscriptionsWithDiscount());

        yield call(trackScreenLoadCancelOffer, {
            screenId: CANCEL_OFFER_SUCCESS_SCREEN_ID,
            eventLabel: { subscription_id: payload.id, offer: CancelFlowOffers.Discount },
        });

        yield put(openModal(ModalName.SuccessModal, getChangeSubscriptionSuccessModalData(payload.product)));

        yield put(fetchDiscountSubscriptionSuccess(null));

        yield call(sendAnalyticDiscountAppliedResult, DISCOUNT_APPLIED_SUCCESS, payload.product.name);
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        yield put(
            openModal(ModalName.RetryErrorModal, {
                ...changeSubscriptionErrorModalData,
                retryAction: () => updateSubscription(payload),
            })
        );

        yield call(
            sendAnalyticDiscountAppliedResult,
            DISCOUNT_APPLIED_ERROR,
            'Subscription plan not updated due to a technical issue'
        );
    }
}
